/**
 * The `{ id, order }` patches that swap one row with its neighbour in an
 * ordered admin list (Promotions, Testimonials, ...).
 *
 * `rows` is the list as displayed — the API already serves it in site order.
 * Distinct `order` values are the API's job (creation assigns max+1), so a
 * plain exchange of the two rows' values is enough. An impossible move (top
 * row up, bottom row down, unknown id) returns [].
 */
export const swapPatches = (rows, id, direction) => {
  const list = rows || [];
  const i = list.findIndex((row) => row._id === id);
  const j = direction === "up" ? i - 1 : i + 1;
  if (i < 0 || j < 0 || j >= list.length) return [];

  return [
    { id: list[i]._id, order: list[j].order ?? 0 },
    { id: list[j]._id, order: list[i].order ?? 0 },
  ];
};
